import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

/** Drop all cached API data (company-scoped chat, docs, reports, workflows, etc.). */
export function clearCompanyScopedCache(): void {
  queryClient.clear();
}
